export default __webpack_public_path__ + "static/media/MODALfrijol.36fa159b.png";